const initialState = {
    examType: null
};

export const setExamType = (examType) => ({
    type: "SET_EXAM_TYPE",
    payload: examType,
});

const examReducer = (state = initialState, action) => {
    switch (action.type) {
        case "SET_EXAM_TYPE":
            return { ...state, examType: action.payload };
        default:
            return state;
    }
};

export default examReducer;
